import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit';
import settings from 'Cloud/settings';
import { REACT_START } from 'reactApp/appHelpers/configHelpers';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { GetStateResponse, IHistoryPush, IStatusPage, RouterState } from 'reactApp/modules/router/router.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';

const initialState: RouterState = {
    id: settings?.request?.id ?? ROOT_FOLDER_ID,
    params: {},
    storage: settings?.request?.storage || (REACT_START ? EStorageType.start : null),
    parent: '',
    status: null,
    preventPush: false,
    historyPath: '',
};

export const routeChangeStart = createAction<GetStateResponse>('router/change/start');
export const routeChangeSuccess = createAction<GetStateResponse>('router/change/success');
export const routerStart = createAction<GetStateResponse>('router/start');
export const applicationStart = createAction('router/applicationStart');
export const routeStatusPage = createAction<IStatusPage>('router/statusPage');
export const historyPush = createAction<IHistoryPush>('router/historyPush');
export const changeHistory = createAction<string>('router/changeHistory');
export const preventHistoryPush = createAction<boolean>('router/preventHistoryPush'); // от срабатываения при смене location.pathname

export const routerReducer = createReducer(initialState, {
    [routerStart.type]: (state, action: PayloadAction<GetStateResponse>) => {
        return {
            ...state,
            id: action.payload.id,
            parent: action.payload.__parent,
            storage: action.payload.storage,
            params: action.payload.params,
        };
    },
    [routeChangeStart.type]: (state, action: PayloadAction<GetStateResponse>) => {
        return {
            ...state,
            id: action.payload.id,
            parent: action.payload.__parent,
            storage: action.payload.storage,
            params: action.payload.params,
        };
    },
    [routeChangeSuccess.type]: (state, action: PayloadAction<GetStateResponse>) => {
        return {
            ...state,
            id: action.payload.id,
            parent: action.payload.__parent,
            storage: action.payload.storage,
            params: action.payload.params,
        };
    },
    [routeStatusPage.type]: (state, action: PayloadAction<IStatusPage>) => {
        return {
            ...state,
            status: action.payload.status,
        };
    },
    [preventHistoryPush.type]: (state, action: PayloadAction<boolean>) => {
        return {
            ...state,
            preventPush: action.payload,
        };
    },
    [changeHistory.type]: (state, action: PayloadAction<string>) => {
        return {
            ...state,
            historyPath: action.payload,
        };
    },
});
